var styles = {"root":"icon-grid-item--root","icon":"icon-grid-item--icon","text":"icon-grid-item--text"};

export { styles as default };
//# sourceMappingURL=IconGridItem.module.esm.js.map
